/**
 * Chrome's built-in Google Translate (and some browser extensions) mutates the
 * DOM behind React's back: text nodes get wrapped in <font> elements. On the
 * next reconciliation, removeChild/insertBefore throw NotFoundError and the
 * whole tree crashes (https://github.com/facebook/react/issues/11538).
 * These patches turn that hard crash into a logged no-op.
 */
export const applyDomSafetyPatches = () => {
	if (typeof Node !== 'function' || !Node.prototype) {
		return;
	}

	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
		if (child.parentNode !== this) {
			console.error('Cannot remove a child from a different parent', child, this);
			return child;
		}
		return originalRemoveChild.call(this, child) as T;
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
		if (referenceNode && referenceNode.parentNode !== this) {
			console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
			return newNode;
		}
		return originalInsertBefore.call(this, newNode, referenceNode) as T;
	};
};
